import React, { memo, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import TopPanel from 'components/top-panel/TopPanel';
import SidebarPanel from 'components/sidebar/SidebarPanel';
import ProjectStatusWatcher from 'components/ProjectStatusWatcher';
import useToggle from 'hooks/useToggle';

const BaseLayout = () => {
  const [sideBarToggle, setSideBarToggle] = useToggle('sidebarOpen');
  const printRef = React.useRef();

  useEffect(() => {
    window.addEventListener('keypress', (event) => {
      if (event && event.keyCode == 91) {
        setSideBarToggle(false);
      }
      if (event && event.keyCode == 93) {
        setSideBarToggle(true);
      }
    });
  }, []);

  return (
    <>
      <ProjectStatusWatcher />
      <div className='flex flex-row relative'>
        <div
          className={`aside-container${
            sideBarToggle ? ' sidebar-full' : ' sidebar-small'
          }`}
        >
          <SidebarPanel
            sideBarToggle={sideBarToggle}
            setSideBarToggle={setSideBarToggle}
          />
        </div>
        <div
          className={`base-container  overflow-x-auto  my-scroll ${
            sideBarToggle ? 'base-container-small' : 'base-container-full'
          } `}
        >
          <div className='min-w-[1200px] h-full'>
            <div className='header-container'>
              <TopPanel
                printRef={printRef}
                onOpenSidebar={setSideBarToggle}
              />
            </div>
            <main
              ref={printRef}
              className='main-container with-max-width bg-[#F2F3F7] h-[calc(100dvh-70px)] sm:h-[calc(100vh-70px)] overflow-y-auto overflow-x-auto  my-scroll'
            >
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(BaseLayout);
